import React from 'react'
import PropTypes from 'prop-types'
import VendorAppointment from './VendorAppointment'

function Massage(props) {
  return (
    <VendorAppointment
      vendorAppointmentId={props.vendorAppointmentId}
      frequencyLabel={'One-time spa service'}
      label={'Spa services type'}
      timeframe={'Space services timeframe'}
    />
  )
}

Massage.propTypes = {
  vendorAppointmentId: PropTypes.string.isRequired,
}

export default Massage
